module.exports = __webpack_public_path__ + "img/sort-down-icon.26c2433c.svg";